module.exports = __webpack_public_path__ + "img/8-min.b08503a1.jpg";